import * as React from "react";

import {states}         from "./states-svg";
import {analyticCount}  from "../analytics-locale";
import {xdQAattribute}  from "../../analytics-layout";
import "./analytics-states.scss";

const KEY_ANALYTIC = 'state'
const INDEX_OUT_OF_BOUNDS = -1
const DISPLAY_MAX = 5

export const AnalyticsStates = ({leadInteractions, colorsFill}) => {
    const viewBox = `0 0 1000 589`
    const [hoveredValue, setHoveredValue] = React.useState(null)
    const values = analyticCount(leadInteractions, KEY_ANALYTIC)
    const stroke="#FFFFFF"

    const fill = "#33415040"
   
    return (
        <div className="state-map-us123" >
            <div className="state-header">
                <h5 
                    className="title"
                    {...xdQAattribute('label', 'state title')}
                >
                    States
                </h5>
                <p 
                    className="subtitle"
                    {...xdQAattribute('text', 'state subtitle')}
                >
                    {subheaderText(values)}
                </p>
            </div>
            <div className="state-data">
                <div className="state-legend">
                    {
                        values.map((value, i) => {
                            const stateId = value[KEY_ANALYTIC]
                            const stateName = stateNameFromId(stateId)
                            const stateCount = value.count

                            return (
                                i < DISPLAY_MAX
                                ? <div 
                                    key={i}
                                    className={`state-list-item-container 
                                        ${stateId === hoveredValue ? ' hovered' : ''}`}
                                >
                                    <li 
                                        className="state-list-item"
                                        style={{color: colorsFill[i % colorsFill.length]}}
                                    >
                                        <span className="state-text">
                                            <p 
                                                className="state-name"
                                                {...xdQAattribute('text', stateName)}
                                            >
                                                {stateName}
                                            </p>
                                            <p 
                                                className="state-count"
                                                {...xdQAattribute('text', `count ${stateName}`)}
                                            >
                                                {stateCount}
                                            </p>
                                        </span>
                                    </li>
                                </div>
                                : null
                            )
                        })
                    
                    }
                </div>
                <svg
                    className="state-map"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox={viewBox}
                    {...xdQAattribute('image', 'state chart')}
                >
                    {
                        states?.map(state => {
                            const stateIndex = analyticIndex(values, state.id)
                            const fillColor = stateIndex === INDEX_OUT_OF_BOUNDS 
                                ? fill 
                                : colorsFill[stateIndex % colorsFill.length]
                        
                            return (
                                <path
                                    className="path-state"
                                    key={state.id}
                                    stroke={stroke}
                                    fill={fillColor}
                                    strokeWidth="1"
                                    d={state.path}
                                    onPointerEnter={() => setHoveredValue(state.id)}
                                    onPointerLeave={() => setHoveredValue(null)}
                                    {...xdQAattribute('image', 'state path')}
                                />
                            )
                        })
                    }
                </svg>
            </div>
        </div>
    )
}

const subheaderText = (values) => {
    if(!values) {
        return 'No leads found'
    }
    if(values.length === 0) {
        return 'No leads found'
    }
    if(values.length === 1) {
        return 'State with the most leads'
    }

    return 'States with the most leads'
}

const analyticIndex = (array, analytic) => {
    for(let i = 0; i < array.length; i++) {
        if(i === DISPLAY_MAX) {
            break
        }

        if(array[i][KEY_ANALYTIC] === analytic) {
            return i
        }
    }

    return INDEX_OUT_OF_BOUNDS
}

const stateNameFromId = (id) => {
    const state = states.find(state => state.id === id)
    return state?.name || ''
}